import {ICurrencyService} from "./currency.service.interface";
import {action, makeObservable, observable} from "mobx";
import {Price} from "./price";
import {ServiceBase} from "../service-base";
import {IServiceFactory} from "../service-factory.interface";
import {RawLocalStorageKeys} from "../storage/raw-local-storage/raw-local-storage-keys";

export class CurrencyService extends ServiceBase implements ICurrencyService {
    constructor(services: IServiceFactory) {
        super(services)
        this.current = 'EUR'; //TODO - get the currency code from the url
        makeObservable(this, {
            current: observable.ref,
            setCurrentCurrency: action.bound,
        });
    }



    current: string;
    readonly defaultCurrency = 'EUR';
    formatMoney(value: number): string {
       return this.formatMoneyForCurrency(value, this.current);
    }

    setCurrentCurrency(value:string) {
        this.current = value;
        this.services.rawLocalStorage.setItem(RawLocalStorageKeys.userProfileCurrency,  value);
    }

    formatNumber(value: number): string {
        return new Intl.NumberFormat(this.services.language.currentLanguage)
            .format(value)
            .replace('\u00A0', ' ') ;
    }

    formatMoneyForCurrency(value: number, currency: string): string {
        let formatOptions: Intl.NumberFormatOptions = {
            style: 'currency',
            currency: currency
        };

        switch (currency) {
            case 'USD':
            case 'EUR':
            case 'GBP':
                formatOptions.currencyDisplay = 'narrowSymbol';
                break;
        }

        let formattedMoney: string;
        try {
            formattedMoney = new Intl.NumberFormat(this.services.language.currentLanguage, formatOptions).format(value);
        } catch (err) {
            formattedMoney = new Intl.NumberFormat(this.services.language.currentLanguage, {
                ...formatOptions,
                currencyDisplay: 'symbol'
            }).format(value);
        }

        return formattedMoney.replace('\u00A0', ' ') ;
    }

    createPrice(amount: number, currency?: string): Price {
        return new Price(amount, currency || this.current, this);
    }

    getCurrencySymbol(currency: string): string {
        switch (currency) {
            case 'EUR':
                return "€";
            case 'USD':
                return "$"
            default:
                return currency;
        }
    }
}
